import {Component, OnInit} from '@angular/core';
import {AboutUsService, IAbout} from 'projects//paid_ukr/src/app/components/about-us/about-us.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  items: IAbout[];


  constructor(private service: AboutUsService) {
  }

  ngOnInit(): void {
    this.items = this.service.getList();
  }

}
